import { InjectionToken } from '@angular/core';
import { UploadTaskHandle } from './upload-facade';

export interface StorageApi {
  startUpload(file: File, folderName: string): UploadTaskHandle;
}

export const STORAGE_API = new InjectionToken<StorageApi>('STORAGE_API');
